
























































































































































































import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import SupplierOfferStep from "./supplierOffer-step.vue";
import Ajax from "@/lib/ajax";
import EditSupplier from "./components/edit-supplier.vue";

class PageCourtRequest extends PageRequest {
  name: string;
  isOnSale: boolean;
  courtId: number;
  supplierId: number;
  sorting: string = "CourtId desc";
}

@Component({
  components: { SupplierOfferStep, EditSupplier },
})
export default class SupplierOffer extends AbpBase {
  //filters
  pagerequest: PageCourtRequest = new PageCourtRequest();

  supplierId: number = 0;
  courtId: number = 0;
  addSupplierOfferModalShow: boolean = false;
  courtList: Array<any> = [];
  supplierList: Array<any> = [];
  supplierOfferId: number = 0;
  editSupplierShow: boolean = false;

  columns = [
    {
      title: this.L("CourtName"),
      ellipsis: true,
      render: (h: any, params: any) => {
        return h("span", params.row.court.name ? params.row.court.name : "");
      },
    },
    {
      title: "供应商名称",
      tooltip: true,
      ellipsis: true,
      render: (h: any, params: any) => {
        return h("span", params.row.supplier.name);
      },
    },

    {
      title: "vip减免",
      slot: "vipReduction",
    },
    {
      title: "返现金额",
      slot: "cashback",
    },

    {
      title: "取消时间",
      width: 70,
      key: "cancelDate",
      render: (h: any, params: any) => {
        return h("span", params.row.cancelDate / 60 + "小时");
      },
    },

    {
      title: this.L("CreationTime"),
      key: "creationTime",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          new Date(params.row.creationTime).toLocaleDateString()
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 200,
      align: "center",
      slot: "action",
    },
  ];

  get list() {
    return this.$store.state.supplierOffer.list;
  }

  get loading() {
    return this.$store.state.supplierOffer.loading;
  }

  get pageSize() {
    return this.$store.state.supplierOffer.pageSize;
  }

  get totalCount() {
    return this.$store.state.supplierOffer.totalCount;
  }

  get currentPage() {
    return this.$store.state.supplierOffer.currentPage;
  }
  handleSpan({ row, column, rowIndex, columnIndex }) {
    // 只处理第一列
    if (columnIndex !== 0) {
      return {
        rowspan: 1,
        colspan: 1,
      };
    }

    const currentCourtName = row.court.name;
    let rowspan = 1;

    // 查看下一行是否也是相同的球场名称
    for (let i = rowIndex + 1; i < this.list.length; i++) {
      if (this.list[i].court.name === currentCourtName) {
        rowspan++;
      } else {
        break;
      }
    }
    // 如果当前行不是合并组的第一行，则不显示该单元格
    if (
      rowIndex > 0 &&
      this.list[rowIndex - 1].court.name === currentCourtName
    ) {
      return {
        rowspan: 0,
        colspan: 0,
      };
    }

    // 返回合并属性
    return {
      rowspan,
      colspan: 1,
    };
  }

  /**
   * @description:更新vip减免和返现金额
   */
  async updateInfo(row) {
    await this.$store.dispatch({
      type: "supplierOffer/update",
      data: row,
    });
    this.$Message.success({
      content: "修改成功",
    });
  }
  /**
   * description：打开修改供应商弹窗
   */
  editSupplier(row) {
    this.supplierOfferId = row.id;
    this.supplierId = row.supplierId;
    this.editSupplierShow = true;
  }
  /**
   * @description：打开添加的弹窗
   */
  openModal() {
    this.supplierId = 0;
    this.courtId = 0;
    this.addSupplierOfferModalShow = true;
  }

  /**
   * @description：编辑供应商报价
   */
  editSupplierOffer(row) {
    this.supplierId = row.supplierId;
    this.courtId = row.courtId;
    this.addSupplierOfferModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("supplierOffer/setCurrentPage", page);
    this.getpage();
  }

  pagesizeChange(pagesize: number) {
    this.$store.commit("supplierOffer/setPageSize", pagesize);
    this.getpage();
  }

  /**
   * @description:删除供应商报价
   */
  async deleteSupplierOffer(row) {
    if (row.isOnSale) {
      this.$Message.error({
        content: "该供应商报价正在使用中,不能删除",
      });
      return;
    }
    await this.$store.dispatch({
      type: "supplierOffer/delete",
      data: {
        id: row.id,
      },
    });
    this.$Message.success("删除成功");
    this.getpage();
  }
  async getSupplierList() {
    return await this.$store
      .dispatch({
        type: "supplier/GetAllSupplierListLabelAndValue",
      })
      .then((res) => {
        if (res && res.data && res.data.result) {
          this.supplierList = res.data.result;
        }
      });
  }

  search() {
    this.$store.commit("supplierOffer/setCurrentPage", 1);
    this.getpage();
  }

  /**
   * @description：获取所有球场的名称和id
   */
  async getCourtList() {
    let reponse = await Ajax.get("/api/services/app/Court/GetAllCourtNames");
    this.courtList = reponse.data.result;
  }

  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "supplierOffer/getAll",
      data: this.pagerequest,
    });
  }

  // /**
  //  * @description：报价的上下架
  //  */
  // async updateIsOnSale(supplierOfferId, isOnSale) {
  //   let data = {
  //     supplierOfferId,
  //     isOnSale,
  //   };
  //   await this.$store
  //     .dispatch({
  //       type: "supplierOffer/updateIsOnSale",
  //       data,
  //     })
  //     .then((res) => {
  //       if (res && res.data && res.data.result == null) {
  //         this.getpage();
  //       }
  //     });
  // }

  async created() {
    await this.getpage();
    await this.getSupplierList();
    await this.getCourtList();
  }
}
